import React from "react";
import { Disclose, Icon, Poptip } from "@optimizely/axiom";
import styles from "./OpalRoleSuggestionInstanceEnablement.module.scss";
import { useOpalBranding } from "../../../hooks/useOpalBranding/useOpalBranding";

export const GenAIDisabledProduct = ({ productName }: { productName: string }) => {
    const { opalName } = useOpalBranding();

    return (
        <Disclose
            key={productName}
            title={
                <div className={styles["container__heading"]}>
                    {productName}
                    <Poptip
                        content={`${opalName} is not currently available for this product`}
                        isInline
                        style={{ paddingLeft: "3px" }}
                        position="right"
                    >
                        <Icon name="circle-info" size="small" data-testid="disabled-product-info-icon" />
                    </Poptip>
                </div>
            }
            isDisabled={true}
        >
            <></>
        </Disclose>
    );
};

GenAIDisabledProduct.displayName = "GenAIDisabledProduct";
